import i18next from 'i18next';
import XHR from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
import SupportedLangCode from './types/SupportedLangCode';

const NAMESPACES: string[] = ['abm', 'api', 'chargebacks', 'common', 'operations', 'summary'];

function init({ langCode }: { langCode: SupportedLangCode }): Promise<typeof i18next> {
  return new Promise((resolve) => {
    i18next
      .use(XHR)
      .use(initReactI18next)
      .init(
        {
          lng: langCode,
          ns: NAMESPACES,
          defaultNS: 'common',
          fallbackLng: {
            'es-AR': ['es'],
            'es-DO': ['es'],
            'es-EC': ['es'],
            default: ['es']
          },
          debug: false, // ['dev', 'staging'].includes(`${process.env.REACT_APP_STAGE}`),
          backend: {
            loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`
          },
          react: {
            useSuspense: false
          }
        },
        () => resolve(i18next)
      );
  });
}

export default init;
